export default (theme) => ({
  container: { width: '100%' },
  button: {
    textTransform: 'none',
    fontSize: '1.825em',
    lineHeight: '1.4em',
    fontWeight: 300,
    padding: '0px',
    '&:hover': { backgroundColor: 'unset' },
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: { fontSize: '1em' },
  },
  menuItem: { display: 'flex' },
  menuItemText: { padding: 0 },
  menuItemCreateDashboardText: {
    color: 'black',
    padding: 0,
  },
  listSubheader: {
    padding: '1rem 1rem 0',
    fontSize: '12px',
    lineHeight: '20px',
    fontWeight: '400',
  },
});
